export function isValidLurkerEvent(event) {
  if (!event || typeof event !== 'object') return false
  const { object_name, object_detail, event_type, data, params } = event
  if (!object_name || !object_detail || !event_type) return false
  if (data && typeof data !== 'object') return false
  if (params && typeof params !== 'object') return false
  return true
}
